import axios, { AxiosError } from 'axios';

export function CheckUnPublishError(error: AxiosError): boolean {
  if (
    axios.isAxiosError(error) &&
    error?.response?.data?.statusCode === 404 &&
    error?.response?.data?.code === 16
  )
    return true;
}
